import { useState, useEffect } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import ProductCard from "@/components/ProductCard";
import { Loader2 } from "lucide-react";

// Match by Shopify handle. Shopify titles carry suffixes like "Racer Jersey (REFLECTIVE)",
// so exact title matching dropped the Jersey and Track Pants from this page.
const RACER_HANDLES = ["racer-jersey", "racer-longsleeve", "racer-track-pants", "nightcall-tee"];
const RACER_NAMES = ["Racer Jersey", "Racer Longsleeve", "Racer Track Pants", "NIGHTCALL Tee"];

export function findRacerProducts(products) {
  return RACER_HANDLES.map((handle, i) =>
    products.find((p) => p.id === handle) ||
    products.find((p) => p.name?.toLowerCase().startsWith(RACER_NAMES[i].toLowerCase()))
  ).filter(Boolean);
}

export default function CollectionPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shopify/products")
      .then(({ data }) => setProducts(data || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const racer = findRacerProducts(products);

  return (
    <div data-testid="collection-page" className="bg-[#0A0A0A] min-h-screen">
      <SEO title="Racer Collection | AERWEAR" description="The AERWEAR Racer Collection: Racer Jersey, Longsleeve and Track Pants. Made to order, free US shipping." />

      <section className="px-6 sm:px-12 pt-20 pb-12 sm:pt-28 sm:pb-16 text-center border-b border-[#8A8A8A]/20">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#8A8A8A] mb-5">The Collection</p>
        <h1 className="text-3xl sm:text-5xl font-medium uppercase tracking-[0.18em] text-[#F2F0EB]">Racer Collection</h1>
      </section>

      {loading ? (
        <div className="flex items-center justify-center py-28"><Loader2 size={24} className="animate-spin text-[#8A8A8A]" /></div>
      ) : (
        <section className="px-6 sm:px-12 py-16 sm:py-24">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 sm:gap-x-6 sm:gap-y-12">
            {racer.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}
    </div>
  );
}
